import React from 'react';
import classNames from 'classnames';
import { LAYOUTS, SIZES } from './constants';

const ColorPalette = ({ colors, size = SIZES.medium, layout = LAYOUTS.oneRow }) => {
  const classes = classNames(
    'ws-ui-color-palette',
    `ws-ui-color-palette--${size}`,
    `ws-ui-color-palette--${layout}`
  );
  const isTwoRowLayout = layout === LAYOUTS.twoRow;

  const itemsPerRow = isTwoRowLayout ? Math.ceil(colors.length / 2) : colors.length;

  return (
    // @ts-ignore TS(2322): Type '{ '--items-per-row': number; }' is not assig... Remove this comment to see the full error message
    <div className={classes} style={{ '--items-per-row': itemsPerRow }}>
      {colors.map((color, idx) => (
        // eslint-disable-next-line yola/react/no-array-index-key
        <div className="ws-ui-color-palette__color" key={idx} style={{ backgroundColor: color }} />
      ))}
    </div>
  );
};

export default ColorPalette;
